/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Notreleased2Inputs */

const id_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produk ini belum dirilis`)
};

const ms_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produk ini belum dikeluarkan`)
};

const da_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette produkt er ikke udgivet endnu`)
};

const de_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Produkt wurde noch nicht veröffentlicht`)
};

const en_us2_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This product has not been released yet`)
};

const es_es2_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este producto aún no ha sido lanzado`)
};

const es_mx2_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este producto aún no ha sido lanzado`)
};

const fil_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang produktong ito ay hindi pa nailalabas`)
};

const fr_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce produit n'a pas encore été publié`)
};

const it_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo prodotto non è ancora stato rilasciato`)
};

const hu_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a termék még nem jelent meg`)
};

const nl_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit product is nog niet uitgebracht`)
};

const no_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette produktet har ikke blitt utgitt ennå`)
};

const pl_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten produkt nie został jeszcze wydany`)
};

const pt_br2_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este produto ainda não foi lançado`)
};

const pt_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este produto ainda não foi lançado`)
};

const ro_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acest produs nu a fost încă lansat`)
};

const fi_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tätä tuotetta ei ole vielä julkaistu`)
};

const sv_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna produkt har inte släppts än`)
};

const vi_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm này chưa được phát hành`)
};

const tr_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu ürün henüz yayınlanmadı`)
};

const cs_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento produkt ještě nebyl vydán`)
};

const bg_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Този продукт все още не е издаден`)
};

const ru_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот продукт ещё не вышел`)
};

const uk_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей продукт ще не випущено`)
};

const ar_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم إصدار هذا المنتج بعد`)
};

const hi_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह उत्पाद अभी तक रिलीज़ नहीं हुआ है`)
};

const th_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผลิตภัณฑ์นี้ยังไม่วางจำหน่าย`)
};

const ja_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この製品はまだリリースされていません`)
};

const zh_cn2_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该产品尚未发布`)
};

const zh_hant1_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該產品尚未發布`)
};

const ko_offerdetail_reviews_notreleased2 = /** @type {(inputs: Offerdetail_Reviews_Notreleased2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 제품은 아직 출시되지 않았습니다`)
};

/**
* | output |
* | --- |
* | "This product has not been released yet" |
*
* @param {Offerdetail_Reviews_Notreleased2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_notreleased2 = /** @type {((inputs?: Offerdetail_Reviews_Notreleased2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Notreleased2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_notreleased2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_notreleased2(inputs)
	if (locale === "da") return da_offerdetail_reviews_notreleased2(inputs)
	if (locale === "de") return de_offerdetail_reviews_notreleased2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_notreleased2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_notreleased2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_notreleased2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_notreleased2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_notreleased2(inputs)
	if (locale === "it") return it_offerdetail_reviews_notreleased2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_notreleased2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_notreleased2(inputs)
	if (locale === "no") return no_offerdetail_reviews_notreleased2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_notreleased2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_notreleased2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_notreleased2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_notreleased2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_notreleased2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_notreleased2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_notreleased2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_notreleased2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_notreleased2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_notreleased2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_notreleased2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_notreleased2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_notreleased2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_notreleased2(inputs)
	if (locale === "th") return th_offerdetail_reviews_notreleased2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_notreleased2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_notreleased2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_notreleased2(inputs)
	return ko_offerdetail_reviews_notreleased2(inputs)
});
export { offerdetail_reviews_notreleased2 as "offerDetail.reviews.notReleased" }